/*
 * @Author: DESKTOP-ROEB53E\caiyangjie 1760178806@qq.com
 * @Date: 2024-01-10 11:03:31
 * @LastEditors: DESKTOP-ROEB53E\caiyangjie 1760178806@qq.com
 * @LastEditTime: 2024-01-19 15:59:17
 * @FilePath: \合联\oms\src\api\analysis\financialRevenue.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios, { buildApi } from '@/libs/api.request';
let name = '/report/income/'

export const apis = buildApi({
  get: [name + 'time', name + 'type', name + 'customer', name + 'contract', name + 'histogram', name + 'detail', name + 'rank'],
  upload: [name + 'excel']
})